<template>
  <div class="setting-user-page">
    <setting-user ref="settingUser"></setting-user>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia'
import { defineComponent } from 'vue'

import SettingUser from '@/client/features/setting_user'
import { useNavbarStore } from '@/client/store/useNavbarStore'

export default defineComponent({
  components: {
    SettingUser
  },
  created() {
    this.setBreadcrumb([
      {
        name: 'ユーザー設定',
        link: null
      }
    ])
  },
  methods: {
    ...mapActions(useNavbarStore, ['setBreadcrumb'])
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    // 離脱チェック
    ;(this.$refs.settingUser as InstanceType<typeof SettingUser>).checkBeforeLeave((err, isExit) => {
      if (err) {
        isExit = false
      }
      next(isExit)
    })
  }
})
</script>
